import { SupportGroup } from "../../api/support";

// Gecici destek grubu listesi. .de /api/support-groups gelince getSupportGroups()
// gercek veriyi dondurur ve bu fallback devre disi kalir (length kontrolu ile).
export const MOCK_SUPPORT_GROUPS: SupportGroup[] = [
    { ref: 1, name: "Teknik Destek", is_active: true },
    { ref: 2, name: "Muhasebe", is_active: true },
    { ref: 3, name: "Satış", is_active: true },
    { ref: 4, name: "Saha Destek", is_active: true },
    { ref: 5, name: "Yazılım", is_active: true },
];
